<template>
  <div id="post-filter-shop-select">
    <label class="form-label">Магазин</label>
    <Multiselect @change="onChange" v-model="fields.shop_id" mode="tags" placeholder="Не выбрано" noResultsText="Результатов не найдено" :close-on-select="true" :options="getValues()" :searchable="true" :trackBy="'title'">
      <template v-slot:tag="{ option, handleTagRemove, disabled }">
        <div class="multiselect-tag element" :class="{ 'is-disabled': disabled }">
          <img :src="option.image">
          <div class="user-name">{{ option.title }}</div>
          <span v-if="!disabled" class="multiselect-tag-remove" @mousedown.prevent="handleTagRemove(option, $event)">
            <span class="multiselect-tag-remove-icon"></span>
          </span>
        </div>
      </template>
      <template v-slot:option="{ option }">
        <div class="option-user">
          <div class="user-image-wrap">
            <img class="user-image" :src="option.image">
          </div>
          <div class="user-name"> {{ option.title }}</div>
        </div>
      </template>
    </Multiselect>
  </div>
</template>

<script>
import "./css/style.css"
import {defineComponent, watch, ref, onMounted, reactive} from "vue"
import Multiselect from "@/plugins/multiselect"
import Api from "@/modules/post/components/filter/components/shops/services/Api"
import Helper from "@/services/Helper"
import ShopImage from "./services/ShopImage"

export default defineComponent({
  name: "Shops",
  components: {
    Multiselect,
  },
  props: {
    data: {
      type: [Object, null],
      default: null,
    },
  },
  setup(props, {emit}) {
    let shopsValues = ref([])

    const fields = reactive({
      shop_id: props.data.val,
    })

    onMounted(async () => {
      fields.shop_id = props.data.val

      let shops = await Api.shops()

      setValues(shops);
    })

    watch(() => props.data.val, (val) => {
      fields.shop_id = val
    })

    watch(() => props.data.shops, (val) => {
      setValues(val)
    })

    function setValues(items) {
      let filtered = []
      for (let prop in items) {
        let obj = items[prop]
        let image = null

        // пропускаем первые 2 элемента
        if (Helper.inArray([obj["id"]], [null])) {
          continue
        }

        if (obj["id"] === -1) {
          image = ShopImage.handle(null, null, 60)
        } else if (obj["image_host"] && obj["image_name"]) {
          image = ShopImage.handle(obj["image_host"], obj["image_name"], 60)
        }

        filtered.push({
          value: obj["id"],
          title: obj["title"],
          search: obj["search"],
          image: image,
        })
      }

      shopsValues.value = filtered
    }

    function getValues() {
      return shopsValues.value;
    }

    function onChange(value) {
      fields.shop_id = value
      emit("onChange", fields.shop_id)
    }

    return {
      onChange,
      getValues,
      fields,
    }
  }
})
</script>
